import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  message: '',
  show: false,
  color: 'error',
  horizontal: 'right',
  vertical: 'bottom',
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: create => ({
    showToast: create.reducer(
      (state, {payload: {show = true, message = '', ...rest} = {}} = {}) => ({
        ...state,
        show,
        message,
        color: 'success',
        ...rest,
      })
    ),
    closeToast: create.reducer(state => ({
      ...state,
      show: false,
    })),
  }),
});

export const toastState = state => state.auth;

export const {closeToast, showToast} = toastSlice.actions;

export default toastSlice.reducer;
